export default __webpack_public_path__ + "static/media/NORTE-01.6d633e86.png";